(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 3370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59499);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(50029);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92495);
/* harmony import */ var _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11267);
/* harmony import */ var _api_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38584);
/* harmony import */ var _api_redux_about__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34577);
/* harmony import */ var _components_innerbanner_v9__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8711);
/* harmony import */ var _components_home_Invest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49982);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var _components_about_CoreValues__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94917);
/* harmony import */ var _components_about_Expert__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31782);
/* harmony import */ var _components_CTA_v3__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69589);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(68777);
/* harmony import */ var _components_about_BestProduct__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96092);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(62642);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(56546);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(39664);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85893);

























gsap__WEBPACK_IMPORTED_MODULE_16__/* ["default"].registerPlugin */ .ZP.registerPlugin(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_17__.ScrollTrigger, gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_18__.ScrollToPlugin);

var About = function About(_ref) {
  var _getPost$posts, _getPost$posts$data, _getPost$posts2, _getPost$posts3, _getPost$posts4, _getPost$posts4$data, _getPost$posts4$data$, _getPost$posts5, _getPost$posts5$data, _getPost$posts5$data$, _getPost$posts6, _getPost$posts6$data, _getPost$posts6$data$, _getPost$posts7, _getPost$posts7$data, _getPost$posts7$data$, _getPost$posts8, _getPost$posts8$data, _getPost$posts8$data$, _banner$images, _banner$images$list, _banner$images$list$, _banner$images2, _banner$images2$list, _banner$images2$list$, _banner$section_data, _banner$section_data2, _banner$images3, _banner$images3$list, _banner$images3$list$;

  var winWidth = _ref.winWidth;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)('90'),
      offset = _useState[0],
      setOffset = _useState[1];

  var getPost = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.aboutReducer;
  });
  var page_data = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts = getPost.posts) === null || _getPost$posts === void 0 ? void 0 : (_getPost$posts$data = _getPost$posts.data) === null || _getPost$posts$data === void 0 ? void 0 : _getPost$posts$data.page_data;
  var expert = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts2 = getPost.posts) === null || _getPost$posts2 === void 0 ? void 0 : _getPost$posts2.expert;
  var board = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts3 = getPost.posts) === null || _getPost$posts3 === void 0 ? void 0 : _getPost$posts3.board;
  var banner = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts4 = getPost.posts) === null || _getPost$posts4 === void 0 ? void 0 : (_getPost$posts4$data = _getPost$posts4.data) === null || _getPost$posts4$data === void 0 ? void 0 : (_getPost$posts4$data$ = _getPost$posts4$data.sections) === null || _getPost$posts4$data$ === void 0 ? void 0 : _getPost$posts4$data$.find(function (f) {
    var _f$section_data;

    return (f === null || f === void 0 ? void 0 : (_f$section_data = f.section_data) === null || _f$section_data === void 0 ? void 0 : _f$section_data.slug) === 'banner-about';
  });
  var investing = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts5 = getPost.posts) === null || _getPost$posts5 === void 0 ? void 0 : (_getPost$posts5$data = _getPost$posts5.data) === null || _getPost$posts5$data === void 0 ? void 0 : (_getPost$posts5$data$ = _getPost$posts5$data.sections) === null || _getPost$posts5$data$ === void 0 ? void 0 : _getPost$posts5$data$.find(function (f) {
    var _f$section_data2;

    return (f === null || f === void 0 ? void 0 : (_f$section_data2 = f.section_data) === null || _f$section_data2 === void 0 ? void 0 : _f$section_data2.slug) === 'overview-about';
  });
  var mission_vision = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts6 = getPost.posts) === null || _getPost$posts6 === void 0 ? void 0 : (_getPost$posts6$data = _getPost$posts6.data) === null || _getPost$posts6$data === void 0 ? void 0 : (_getPost$posts6$data$ = _getPost$posts6$data.sections) === null || _getPost$posts6$data$ === void 0 ? void 0 : _getPost$posts6$data$.find(function (f) {
    var _f$section_data3;

    return (f === null || f === void 0 ? void 0 : (_f$section_data3 = f.section_data) === null || _f$section_data3 === void 0 ? void 0 : _f$section_data3.slug) === 'mission-vision';
  });
  var core_values = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts7 = getPost.posts) === null || _getPost$posts7 === void 0 ? void 0 : (_getPost$posts7$data = _getPost$posts7.data) === null || _getPost$posts7$data === void 0 ? void 0 : (_getPost$posts7$data$ = _getPost$posts7$data.sections) === null || _getPost$posts7$data$ === void 0 ? void 0 : _getPost$posts7$data$.find(function (f) {
    var _f$section_data4;

    return (f === null || f === void 0 ? void 0 : (_f$section_data4 = f.section_data) === null || _f$section_data4 === void 0 ? void 0 : _f$section_data4.slug) === 'our-core-values';
  });
  var about_cta = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts8 = getPost.posts) === null || _getPost$posts8 === void 0 ? void 0 : (_getPost$posts8$data = _getPost$posts8.data) === null || _getPost$posts8$data === void 0 ? void 0 : (_getPost$posts8$data$ = _getPost$posts8$data.sections) === null || _getPost$posts8$data$ === void 0 ? void 0 : _getPost$posts8$data$.find(function (f) {
    var _f$section_data5;

    return (f === null || f === void 0 ? void 0 : (_f$section_data5 = f.section_data) === null || _f$section_data5 === void 0 ? void 0 : _f$section_data5.slug) === 'about-cta';
  }); // get offset for container

  (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function () {
    if (window.innerWidth > 767) {
      setOffset(document.querySelector('.container').offsetLeft + 15);
    }
  });
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
  var currentUrl = router && router.asPath; // on page load go down

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(''),
      id = _useState2[0],
      setId = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function () {
    var hash = window.location.hash;
    var urlHasHash = hash && typeof hash === 'string' && hash.startsWith('#');

    if (urlHasHash) {
      setTimeout(function () {
        setId(hash);
        gsap__WEBPACK_IMPORTED_MODULE_16__/* ["default"].to */ .ZP.to(window, {
          scrollTo: {
            y: hash,
            // y:900,
            autoKill: true
          },
          ease: 'Power1.easeOut'
        });
      }, 600);
    }

    gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_17__.ScrollTrigger.refresh();
  }, [router]);
  (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function () {
    var hash = window.location.hash;

    if (id) {
      var _document$getElementB;

      var theId = (_document$getElementB = document.getElementById("".concat(hash))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.offsetTop;
      gsap__WEBPACK_IMPORTED_MODULE_16__/* ["default"].to */ .ZP.to(window, {
        scrollTo: {
          y: theId,
          // y:900,
          autoKill: true
        },
        ease: 'Power1.easeOut'
      });
    }

    gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_17__.ScrollTrigger.refresh();
  }, [id, router]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
      title: "".concat(page_data !== null && page_data !== void 0 && page_data.title ? (page_data === null || page_data === void 0 ? void 0 : page_data.title) + ' | Shanta Securities Limited' : 'Shanta Securities Limited'),
      description: page_data === null || page_data === void 0 ? void 0 : page_data.meta_description,
      canonical: "https://www.shantasecurities.com" + currentUrl,
      openGraph: {
        type: 'website',
        url: "https://www.shantasecurities.com" + currentUrl,
        title: page_data === null || page_data === void 0 ? void 0 : page_data.og_title,
        description: page_data === null || page_data === void 0 ? void 0 : page_data.og_description,
        images: [{
          url: banner === null || banner === void 0 ? void 0 : (_banner$images = banner.images) === null || _banner$images === void 0 ? void 0 : (_banner$images$list = _banner$images.list) === null || _banner$images$list === void 0 ? void 0 : (_banner$images$list$ = _banner$images$list[0]) === null || _banner$images$list$ === void 0 ? void 0 : _banner$images$list$.full_path,
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }, {
          url: banner === null || banner === void 0 ? void 0 : (_banner$images2 = banner.images) === null || _banner$images2 === void 0 ? void 0 : (_banner$images2$list = _banner$images2.list) === null || _banner$images2$list === void 0 ? void 0 : (_banner$images2$list$ = _banner$images2$list[0]) === null || _banner$images2$list$ === void 0 ? void 0 : _banner$images2$list$.full_path,
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsxs)(StyledComponent, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_innerbanner_v9__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        title: banner === null || banner === void 0 ? void 0 : (_banner$section_data = banner.section_data) === null || _banner$section_data === void 0 ? void 0 : _banner$section_data.subtitle,
        text: banner === null || banner === void 0 ? void 0 : (_banner$section_data2 = banner.section_data) === null || _banner$section_data2 === void 0 ? void 0 : _banner$section_data2.short_desc,
        src: banner === null || banner === void 0 ? void 0 : (_banner$images3 = banner.images) === null || _banner$images3 === void 0 ? void 0 : (_banner$images3$list = _banner$images3.list) === null || _banner$images3$list === void 0 ? void 0 : (_banner$images3$list$ = _banner$images3$list[0]) === null || _banner$images3$list$ === void 0 ? void 0 : _banner$images3$list$.full_path
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        id: 'who-we-are',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_home_Invest__WEBPACK_IMPORTED_MODULE_8__["default"], {
          bigtitle: true,
          padding: 'pt-80',
          data: investing,
          browchure: true,
          title: '',
          offset: offset
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        id: 'mission-vision',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_about_BestProduct__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          data: mission_vision,
          offset: offset
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        id: 'core-values',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_about_CoreValues__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          data: core_values
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        id: 'our-board',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_about_Expert__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          winWidth: winWidth,
          data: board,
          title: 'Our <span>Board</span>'
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)("div", {
        id: 'our-team',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_about_Expert__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          winWidth: winWidth,
          data: expert,
          padding: 'pt-0',
          title: 'Our <span>Team</span>'
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__.jsx)(_components_CTA_v3__WEBPACK_IMPORTED_MODULE_12__["default"], {
        data: about_cta,
        winWidth: winWidth,
        offset: offset
      })]
    })]
  });
};

About.getInitialProps = _api_store__WEBPACK_IMPORTED_MODULE_5__/* .wrapper.getInitialPageProps */ .YS.getInitialPageProps(function (store) {
  return /*#__PURE__*/(0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _param;

    var api_services, param;
    return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api_services = _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_3__/* .ApiServices.SECTIONS */ .u.SECTIONS;
            param = (_param = {}, (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.TYPE */ .j.TYPE, 'slug'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.VALUE */ .j.VALUE, 'about-us'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.GET_SECTION */ .j.GET_SECTION, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.IMAGE */ .j.IMAGE, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.POST */ .j.POST, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_4__/* .ApiParamKey.GALLERY */ .j.GALLERY, 'yes'), _param);
            _context.next = 4;
            return store.dispatch((0,_api_redux_about__WEBPACK_IMPORTED_MODULE_6__/* .fetchPosts */ .T6)([api_services, param]));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});
var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_21__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "about__StyledComponent",
  componentId: "sc-umxwtb-0"
})([".lube-testing{background:#f2f2f2;padding-bottom:200px;@media (max-width:767px){padding-bottom:120px;.lube-testing__text{margin-top:40px;}.bigtitle{margin-bottom:0;}.container-fluid{.row{flex-direction:column;}}}}"]);
/* harmony default export */ __webpack_exports__["default"] = (About);

/***/ }),

/***/ 5401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(3370);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7724,7006,7055,8800,9617,9774,2888,179], function() { return __webpack_exec__(5401); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);